import { RootState } from "../hooks";

export const getUsersSelector = (state: RootState) => state.users;
